import { createSelector } from '@ngrx/store';
import { PageLoadingState } from '../models/assessment-models';

export const selectLoadingState = (state: any): PageLoadingState => state.loadingData;

export const selectPageLoading = createSelector(selectLoadingState, (state) => state?.loadingData);
